import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
//import { FormIndicationExam} from './FormIndicationExam'
import { FormIndicationExamMicrobiology } from './FormIndicationExamMicrobiology';
import { Dialog } from 'primereact/dialog';

export const ModalIndicationExamMicrobiology = (props) => {

    const {

        toggle2, modal2,modalTitle, loading,method,listIndications,indication,handleChangeIndication,
        id_exam_indication,indicationn,listIndication,selectIndication,removeExamProfile,CreateOrUpdateExamIndications,
        handleSelectValuesIndication,dataIndication,listIndicationLab, CreateOrUpdateExamLabIndications,handleSelectValuesIndication2,
        dataIndicationLab

        
    }= props;

    return (
        
        <Dialog
            header={modalTitle}
            visible={modal2}
            modal
            dismissableMask
            onHide={toggle2}
            className="large-dialog"
            headerStyle={{
                backgroundColor: "#0d3b59",
                color: "white",
                fontWeight: "bold",
                letterSpacing: "0.5px"
            }}
        >
            
            {
                method === "list"
                    ? <FormIndicationExamMicrobiology
                        button="Guardar"
                        {...{ toggle2, loading,listIndications,indication,handleChangeIndication,id_exam_indication,
                            indicationn,listIndication,selectIndication,removeExamProfile,CreateOrUpdateExamIndications,
                            handleSelectValuesIndication,dataIndication,listIndicationLab, CreateOrUpdateExamLabIndications, 
                            handleSelectValuesIndication2,dataIndicationLab
                        }}
                    />
                    : (method === "update")
                
            }
        </Dialog>
       
    )
}
